import { render } from "./DetailStepServices.vue?vue&type=template&id=00ce83fa"
import script from "./DetailStepServices.vue?vue&type=script&lang=js"
export * from "./DetailStepServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/DetailStepServices.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00ce83fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00ce83fa', __exports__)) {
    api.reload('00ce83fa', __exports__)
  }
  
  module.hot.accept("./DetailStepServices.vue?vue&type=template&id=00ce83fa", () => {
    api.rerender('00ce83fa', render)
  })

}


export default __exports__